import { Card, FloraButton, FloraTypography, styled, Tag } from '@grupoboticario/flora-react';
import { theme, theme as UITheme } from 'ui/theme';
const styles = {
  PaymentsContainer: styled('div', {
    display: 'flex',
    flexDirection: 'column',
    padding: '$4',
    width: '100%',
    rowGap: '$4',
  }),
  PaymentOption: styled(Card, {
    '&[data-stargate]': {
      display: 'flex',
      cursor: 'pointer',
      padding: '$4',
      '&::before': {
        borderRadius: '$small',
        boxShadow: 'none',
        border: '$borderWidths$hairline solid $nonInteractiveOutline',
      },
    },
    '&[data-border-emphansis="true"]': {
      '&::before': {
        border: '$borderWidths$hairline solid $nonPrimaryButtonStroke',
      },
    },
  }),
  PaymentOptionsLabels: styled('div', {
    display: 'flex',
    flexDirection: 'column',
    flex: 8,
    rowGap: '$2',
    '> span': {
      width: '100%',
      height: 'auto',
      color: `${theme.colors.build.mediumLight1}`,
    },
  }),
  PaymentOptionTitle: styled(FloraTypography, {
    fontWeight: 500,
    fontSize: '14px',
  }),
  PaymentOptionDescription: styled(FloraTypography, {
    fontSize: UITheme.space['3'],
    maxWidth: '400px',
  }),
  PaymentOptionIcon: styled('div', {
    display: 'flex',
    padding: '$2',
    background: `${theme.colors.build.lightDark1}`,
    borderRadius: UITheme.space['2'],
    marginRight: UITheme.space['3'],
    height: 'fit-content',
  }),
  PaymentOptionBadge: styled(Tag, {
    '&[data-stargate]': {
      backgroundColor: '$statusSuccessBackgroundAlt',
      position: 'absolute',
      top: '$4',
      right: '$10',
    },
  }),
  BackToCartButton: styled(FloraButton, {
    backgroundColor: `transparent !important`,
    boxShadow: `0 0 0 1px ${theme.colors.action.navigation.standard.static} !important`,
    color: `${theme.colors.action.navigation.standard.static} !important`,
    borderColor: 'transparent !important',
    '&:hover': {
      backgroundColor: `${theme.colors.action.navigation.standard.highlight} !important`,
      boxShadow: `0 0 0 1px ${theme.colors.build.lightLight} !important`,
      color: `${theme.colors.build.lightLight} !important`,
    },
  }),
};

export default styles;
